import { render } from "./TestConfirmTips.vue?vue&type=template&id=b611443e&scoped=true"
import script from "./TestConfirmTips.vue?vue&type=script&lang=js"
export * from "./TestConfirmTips.vue?vue&type=script&lang=js"

import "./TestConfirmTips.vue?vue&type=style&index=0&id=b611443e&scoped=true&lang=css"

import exportComponent from "D:\\eazyc\\ezDev\\ECS-Cognitive\\cognitive-screening-mobile-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b611443e"]])

export default __exports__